import Vue from 'vue';
import VueRouter from 'vue-router';
import utils from './utils';
// import NotFound from '@/components/common/NotFound';

Vue.use(VueRouter);

let routes = null;
if (process.env.NODE_ENV !== 'production') {
  routes = [
    require('./open').default,
    require('./auth').default,
    require('./backend').default
  ];
} else {
  if (process.env.APP_MODE === 'backend') {
    routes = [require('./backend').default];
  } else if (process.env.APP_MODE === 'internal-apply') {
    routes = [require('./auth').default];
  } else if (process.env.APP_MODE === 'open') {
    routes = [require('./open').default];
  } else if (process.env.APP_MODE === 'all') {
    routes = [require('./auth').default, require('./backend').default];
  } else {
    routes = [];
  }
}

routes.push({
  path: '*',
  redirect: '/open'
}, {
  path: '/',
  redirect: routes[0].path
});

export const RouteMapper = utils.createRouteMapper(routes);
export default new VueRouter({
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js